export default __webpack_public_path__ + "static/media/recalculate-icon.c7d177ef.svg";